var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-block"},[_c('div',{staticClass:"graph-area graph-area__KeywordMap"},[_c('div',{staticClass:"sticky_scroll"},[_c('perfect-scrollbar',{attrs:{"options":{
          suppressScrollX: false,
          suppressScrollY: true,
          minScrollbarLength: 10
        }}},[_c('div',{staticClass:"graph-area graph-area__KeywordMap-position"},_vm._l((_vm.data.items),function(item,index){return _c('ListItemTrendMap',{key:index,ref:"text",refInFor:true,attrs:{"item":item}})}),1)])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }